import React from "react";
import {
  Box,
  Heading,
  Text,
  Container,
  Button,
  Flex,
  SimpleGrid,
  Link,
} from "@chakra-ui/react";
import { ActiveLinkProvider } from "./ActiveLinkContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import img from "../images/salon3.jpg";

function Contact() {
  return (
    <ActiveLinkProvider>
      <Header />
      <Box
        height={"60vh"}
        position="relative"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundImage={img}
      ></Box>
      <Box
        as="section"
        id="contact"
        py={16}
        bg={
          "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
        }
        borderBottom={"1px solid white"}
      >
        <Container maxW="container.lg">
          <Heading
            textAlign="left"
            mb={8}
            fontWeight={"600"}
            color={"#f56ee8"}
            fontFamily={"Playwrite DE SAS"}
          >
            Contact Us
          </Heading>
          <Flex justify="space-around" direction="column" align="left">
            <Text fontSize="lg">
              Address: 11400 4th St., Suite 102 Rancho Cucamonga
            </Text>
            <Text fontSize="lg">Phone: (909) 697-0951</Text>
            <Text
              fontSize="lg"
              fontWeight={"600"}
              mt={"15px"}
              color={"pink.300"}
              fontFamily={"Playwrite DE SAS"}
            >
              Hours of Operation:{" "}
            </Text>
            <Text fontSize="lg">Tuesday - Friday 10:00am -6:00pm </Text>
            <Text fontSize="lg">Saturday 9:00am - 4:00pm</Text>
            <br />
            <Text
              fontSize="lg"
              fontWeight={"600"}
              mt={"15px"}
              color={"pink.300"}
              fontFamily={"Playwrite DE SAS"}
            >
              Connect With Us:{" "}
            </Text>
            <Text fontSize="lg">
              Follow me on Instagram: @annienguyenlashes
            </Text>
            <br />
            <Text fontSize="lg" mt={"10px"}>
              Feel free to reach out with any questions or to book an
              appointment. We’re here to assist you and provide you with the
              best nail care and salon services. Your beauty and relaxation are
              our top priorities.
            </Text>
            <Text
              fontSize={"lg"}
              padding={"20px"}
              fontWeight={"700"}
              fontFamily={"Dosis"}
            >
              Note: All Services require a cancellation notification 24 hours
              prior. Failure to do so will result in a fee of $25. Thank you for
              your consideration.
            </Text>
          </Flex>
        </Container>
      </Box>

      <Box bg="pink" py={10} textAlign="center" paddingBottom={"100px"}>
        <Button
          as="a"
          href="#"
          rounded="full"
          size="lg"
          px={10}
          py={6}
          mb={"20px"}
          bg="pink.300"
          color="white"
          _hover={{ bg: "pink.500" }}
          onClick={() => {
            window.location.href =
              "https://www.google.com/maps/place/11400+Fourth+St+%23102,+Rancho+Cucamonga,+CA+91730/@34.0776817,-117.5582929,17z/data=!3m1!4b1!4m5!3m4!1s0x80c33583fed41d21:0x67ceb81e5efa4002!8m2!3d34.0776817!4d-117.555718?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D";
          }}
        >
          Get Directions
        </Button>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} mt={10}>
          <Box>
            <Heading size="md" color="pink.300">
              Visit Us
            </Heading>
            <Text color="gray.600">
              11400 4th St., Suite 102
              <br />
              Rancho Cucamonga, CA 91730
            </Text>
          </Box>
          <Box>
            <Heading size="md" color="pink.300">
              Call Us
            </Heading>
            <Text color="gray.600">Phone: (909) 697-0951</Text>
          </Box>
          <Box>
            <Heading size="md" color="pink.300">
              Follow Us
            </Heading>
            <Link
              href="https://www.instagram.com/annienguyenlashes/?igsh=MzRlODBiNWFlZA%3D%3D"
              color="gray.600"
            >
              Instagram: @annienguyenlashes
            </Link>
          </Box>
        </SimpleGrid>
      </Box>
      <Footer />
    </ActiveLinkProvider>
  );
}

export default Contact;
